// src/routes/AppRoutes.jsx
import { Navigate, Route, Routes, useNavigate } from 'react-router';
import Step1Intent from "./components/wizard/steps/Step1Intent";
import AuthGate from "./components/wizard/steps/AuthGate";
import { OnboardingRouter, PrivateRoute, RedirectIfAuthenticated } from "./App";
import { ForgotPassword, Login, Register, ResetPassword, VerifyEmail } from "./components/auth";
import Dashboard from "./components/dashboard/Dashboard";
import ProjectJiraItemsPage from "./pages/ProjectJiraItemsPage";
import AutomatedTestScenarioGeneratorPage from "./pages/AutomatedTestScenarioGeneratorPage";
import TestCasePage from "./pages/TestCasePage";
import AITestCasePage from "./pages/AITestCasePage";
import NotFound from "./pages/NotFound";


export default function AppRoutes() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("user");
    localStorage.removeItem("robitest_onboarding_draft_v1");

    navigate("/auth/login");
  };

  return (
    <Routes>
      {/* Wizard routes (Public) */}
      <Route
        path="/get-started"
        element={
          <RedirectIfAuthenticated>
            <Step1Intent />
          </RedirectIfAuthenticated>
        }
      />
      <Route
        path="/get-started/auth"
        element={
          <RedirectIfAuthenticated>
            <AuthGate />
          </RedirectIfAuthenticated>
        }
      />

      {/* Wizard routes (Private) */}
      <Route
        path="/app/onboarding"
        element={
          <PrivateRoute>
            <OnboardingRouter />
          </PrivateRoute>
        }
      />

      {/* Auth routes */}
      <Route
        path="/auth/login"
        element={
          <RedirectIfAuthenticated>
            <Login />
          </RedirectIfAuthenticated>
        }
      />
      <Route
        path="/auth/signup"
        element={
          <RedirectIfAuthenticated>
            <Register />
          </RedirectIfAuthenticated>
        }
      />
      <Route
        path="/auth/forgot-password"
        element={
          <RedirectIfAuthenticated>
            <ForgotPassword />
          </RedirectIfAuthenticated>
        }
      />
      <Route
        path="/auth/reset-password/:token"
        element={
          <RedirectIfAuthenticated>
            <ResetPassword />
          </RedirectIfAuthenticated>
        }
      />
      <Route
        path="/auth/reset-password"
        element={
          <RedirectIfAuthenticated>
            <ResetPassword />
          </RedirectIfAuthenticated>
        }
      />
      <Route
        path="/auth/verify-email/:token"
        element={
          <RedirectIfAuthenticated>
            <VerifyEmail />
          </RedirectIfAuthenticated>
        }
      />

      {/* Legacy redirects */}
      <Route path="/login" element={<Navigate to="/auth/login" replace />} />
      <Route path="/register" element={<Navigate to="/auth/signup" replace />} />
      <Route path="/forgot-password" element={<Navigate to="/auth/forgot-password" replace />} />
      {/* Backend email links use /reset-password/:token */}
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/reset-password" element={<Navigate to="/auth/reset-password" replace />} />
      {/* Backend email links use /verify-email/:token */}
      <Route path="/verify-email/:token" element={<VerifyEmail />} />

      {/* Dashboard routes */}
      <Route
        path="/:workspaceId/:projectSegment/dashboard/*"
        element={
          <PrivateRoute>
            <Dashboard onLogout={handleLogout} />
          </PrivateRoute>
        }
      />

      <Route
        path="/:workspaceId/dashboard/*"
        element={
          <PrivateRoute>
            <Dashboard onLogout={handleLogout} />
          </PrivateRoute>
        }
      />

      <Route
        path="/dashboard/*"
        element={
          <PrivateRoute>
            <Dashboard onLogout={handleLogout} />
          </PrivateRoute>
        }
      />

      {/* Full page routes */}
      <Route path="/jira-items/:id" element={<ProjectJiraItemsPage />} />
      <Route path="/automated-scenario/:id" element={<AutomatedTestScenarioGeneratorPage />} />
      <Route path="/test-cases/:id" element={<TestCasePage />} />
      <Route path="/ai-test-case/:id" element={<AITestCasePage />} />

      {/* Fallbacks */}
      <Route path="/" element={<Navigate to="/get-started" />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
